import ProblemSection from "@/components/landing/sections/ProblemSection";
import SolutionsSection from "@/components/landing/sections/SolutionsSection";
import HighlightsSection from "@/components/landing/sections/HighlightsSection";
import DownloadsSection from "@/components/landing/sections/DownloadsSection";
import EnnosVideoSection from "@/components/landing/sections/EnnosVideoSection";
import WhySection from "@/components/landing/sections/WhySection";
import SuccessSection from "@/components/landing/sections/SuccessSection";
import InvestSection from "@/components/landing/sections/InvestSection";
import DonationSection from "@/components/landing/sections/DonationSection";
import FAQSection from "@/components/landing/sections/FAQSection";

const ContentSections = () => (
  <>
    <ProblemSection />
    <SolutionsSection />
    <HighlightsSection />
    <DownloadsSection />
    <EnnosVideoSection />
    <WhySection />
    <SuccessSection />
    <InvestSection />
    <DonationSection />
    <FAQSection />
  </>
);

export default ContentSections;